import { arrayValidation } from 'utils/array';
import type { Column } from 'api/shared/models';

export const getColumnsByConfiguration = (
  columns: Column[] = [],
  sortColumns: Column[] = [],
) => {
  let newAvailableColumns: Column[] = [];
  let newMyColumns: Column[] = [];
  if (arrayValidation(columns)) {
    newAvailableColumns = columns
      .filter((item) => item.status && item.label)
      .filter((item) => {
        const option = sortColumns.find(
          (itemSort) => itemSort.apiField === item.apiField,
        );
        if (option) return false;
        return true;
      });
    newMyColumns = sortColumns.filter((item) => {
      const option = columns.find(
        (itemOriginal) =>
          itemOriginal.apiField === item.apiField && itemOriginal.status,
      );
      if (option) return true;
      return false;
    });
  }

  return {
    newAvailableColumns,
    newMyColumns,
  };
};
